<app-header></app-header>

<div class="container mt-5 mb-5">
  <div class="container image-container text-center">
    <img src="/assets/password-changed-succes.png" alt="" height="250" />
    <div class="text-center">
      <h1 style="color: #00943a">
        <strong>Password changed</strong>
      </h1>
      <p style="font-size: 16px; padding: 1srem 0px">
        Your password has now been changed, click the button below to go your
        login
      </p>
      <!-- <button mat-raised-button color="primary">
        <a href="/login" style="color: #fff">Proceed to login</a>
      </button> -->
      <button
      mat-stroked-button
      [style.width.%]="30"
      style="
        background-color: #00943a;
        color: #ffffff;
        font-size: 16px;
        height: 50px;
        padding-left: 0px;
        padding-right: 0px;
      "
      type="button"
      (click)="navigateLogin()"
    >
    <a href="/login" style="color: #fff">Proceed to login</a>
  </button>
    </div>
  </div>
</div>

<app-footer></app-footer>
